<script setup lang="ts">
import { PhGear } from '@phosphor-icons/vue'
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from '@/components/ui/sheet'
import SettingsSidebarBody from '@/components/sidebar/SettingsSidebarBody.vue'

interface Props {
  open: boolean
  quranState: {
    selectedFont: string
    selectedReciter: string
    showTransliteration: boolean
    showTranslation: boolean
    showAudio: boolean
  }
}

defineProps<Props>()

const emit = defineEmits<{
  'update:open': [value: boolean]
  'update:selectedFont': [value: string]
  'update:selectedReciter': [value: string]
  'update:showTransliteration': [value: boolean]
  'update:showTranslation': [value: boolean]
  'update:showAudio': [value: boolean]
}>()
</script>

<template>
  <Sheet :open="open" @update:open="emit('update:open', $event)">
    <SheetContent side="right" class="w-[min(20rem,calc(100vw-1rem))] sm:w-96">
      <SheetHeader>
        <SheetTitle class="flex items-center gap-2">
          <PhGear :size="20" class="text-moss-500" />
          Settings
        </SheetTitle>
        <SheetDescription>Fonts, audio, and how text appears on each page</SheetDescription>
      </SheetHeader>

      <SettingsSidebarBody
        :quran-state="quranState"
        @update:selected-font="emit('update:selectedFont', $event)"
        @update:selected-reciter="emit('update:selectedReciter', $event)"
        @update:show-transliteration="emit('update:showTransliteration', $event)"
        @update:show-translation="emit('update:showTranslation', $event)"
        @update:show-audio="emit('update:showAudio', $event)"
      />
    </SheetContent>
  </Sheet>
</template>
